// Page Header — Parallax hero
//
// 1. Floating telemetry cards drift at different speeds as the page scrolls.
//    Each card's slot position comes from CSS; this only adds a translateY
//    offset of scrollY * depth (the data-parallax-depth factor set per card
//    by the Drift field). Skipped entirely for prefers-reduced-motion.
//
// 2. "Watch the Video" modal: the iframe src is only set when the modal opens
//    (with autoplay baked into the embed URL) and cleared again on close so
//    playback stops — the framework modal.js does not do this itself.

import $ from 'jquery';

$(function () {
  const hero = document.querySelector('.hero-parallax');

  if (!hero) {
    return;
  }

  // --------------------------------------------------
  // Card drift
  // --------------------------------------------------

  const cards = hero.querySelectorAll('[data-parallax-depth]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (cards.length && !reducedMotion.matches) {
    let ticking = false;

    const update = () => {
      ticking = false;

      // Cards are display: none on mobile — nothing to move.
      if (!cards[0].offsetParent) {
        return;
      }

      cards.forEach((card) => {
        const depth = parseFloat(card.dataset.parallaxDepth) || 0;

        card.style.transform = `translate3d(0, ${window.scrollY * depth}px, 0)`;
      });
    };

    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      },
      { passive: true }
    );

    update();
  }

  // --------------------------------------------------
  // Video modal
  // --------------------------------------------------

  const $modal = $('#modal-hero-parallax-video');
  const $player = $('#modal-hero-parallax-video-player');
  const isSelfHosted = $player.is('video');

  if ($modal.length && $player.length) {
    $('[data-modal-show="modal-hero-parallax-video"]').on('click', (event) => {
      const embed = $(event.currentTarget).data('videoEmbed');

      // Embedded (YouTube/Vimeo): lazy-set the iframe src on open. The
      // self-hosted <video> keeps its src and is played instead.
      if (embed && !isSelfHosted) {
        $player.attr('src', embed);
      }
    });

    if (isSelfHosted) {
      $modal.on('modal:afterShow', () => {
        $player.get(0).play();
      });

      $modal.on('modal:beforeHide', () => {
        $player.get(0).pause();
      });
    } else {
      $modal.on('modal:beforeHide', () => {
        $player.attr('src', '');
      });
    }
  }
});
